import Utils from "../utils/Utils";

const getAuth = ({ jwt, Authorization } = {}) => jwt || Authorization || "";

const addParam = (params, key, value) => {
  if (value !== undefined && value !== null && value !== "") {
    params.append(key, value);
  }
};

const productController = {
  addCampaign: ({ Authorization, jwt, request } = {}) => {
    return Utils.controller(
      "api/product/v1/addCampaign",
      request,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  addProduct: ({ Authorization, productRequestDto }) => {
    return Utils.controller(
      "api/product/v1/addProduct",
      productRequestDto,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },

  updateProduct: ({
    Authorization,
    jwt,
    productId,
    productID,
    productRequestDto,
  } = {}) => {
    const params = new URLSearchParams();
    const productIdToUpdate = productId || productID;

    addParam(params, "productId", productIdToUpdate);

    return Utils.controller(
      "api/product/v1/updateProduct",
      productRequestDto,
      "PUT",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
      "*/*",
    );
  },

  getProductCatalog: ({
    Authorization,
    brand,
    categoryType,
    color,
    companyID,
    companyId,
    jwt,
    maxPrice,
    minPrice,
    page = 1,
    search,
    size,
    sizePage = 10,
    sortBy,
    sortDirection,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "brand", brand);
    addParam(params, "categoryType", categoryType);
    addParam(params, "color", color);
    addParam(params, "companyID", companyID || companyId);
    addParam(params, "maxPrice", maxPrice);
    addParam(params, "minPrice", minPrice);
    addParam(params, "page", page);
    addParam(params, "search", search);
    addParam(params, "size", size);
    addParam(params, "sizePage", sizePage);
    addParam(params, "sortBy", sortBy);
    addParam(params, "sortDirection", sortDirection);

    return Utils.controller(
      "api/product/v1/getProductCatalog",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getProductCatalogDetails: ({
    Authorization,
    businessProfileID,
    businessProfileId,
    companyId,
    companyID,
    jwt,
    productId,
    productID,
  } = {}) => {
    return Utils.controller(
      "api/product/v1/getProductCatalogDetails",
      {
        businessProfileID: businessProfileID || businessProfileId || "",
        companyId: companyId || companyID || "",
        productId: productId || productID || "",
      },
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getProductDetails: ({
    Authorization,
    businessProfileID,
    businessProfileId,
    companyId,
    companyID,
    jwt,
    productId,
    productID,
  } = {}) => {
    return Utils.controller(
      "api/product/v1/getProductDetails",
      {
        businessProfileID: businessProfileID || businessProfileId || "",
        companyId: companyId || companyID || "",
        productId: productId || productID || "",
      },
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getSubCategoriesByCategory: ({ categoryId, request } = {}) => {
    return Utils.controller(
      "api/product/v1/getSubCategoriesByCategory",
      request || { categoryId },
      "POST",
      "",
      false,
      "",
      true,
    );
  },

  getQuickActions: ({ Authorization, companyId, companyID, jwt } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);

    return Utils.controller(
      "api/product/v1/getQuickActions",
      "",
      "PUT",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  deleteProductByProductId: ({
    Authorization,
    jwt,
    productId,
    productID,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "productId", productId || productID);

    return Utils.controller(
      "api/product/v1/deleteProductByProductId",
      "",
      "DELETE",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },
};

export default productController;
